import { isInIframe } from "helpers/app";
import { getItem, saveItem } from "services/local-storage";

export const withVar = (token: string): string => `var(${token})`;
export const withPx = (value: number): string => `${value}px`;

export const THEME_LOCAL_STORAGE_KEY = "hd_theme";
const DEFAULT_THEME: Theme = "light";

export const Theme = {
  Light: "light",
  Dark: "dark",
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];

export const ThemeClass: Record<Theme, string> = {
  light: "lc-light-theme",
  dark: "lc-dark-theme",
};

export const setTheme = (newTheme: Theme): void => {
  const oldTheme = newTheme === "light" ? "dark" : "light";
  document.body.classList.remove(ThemeClass[oldTheme]);
  document.body.classList.add(ThemeClass[newTheme]);
};

export const getInitialTheme = (): Theme => {
  const themeFromLocalStorage = getThemeFromLocalStorage();
  const themeFromUrl = getThemeFromUrl();
  const inFrame = isInIframe();
  return inFrame ? themeFromUrl : themeFromLocalStorage;
};

export const getThemeFromLocalStorage = (): Theme => {
  const theme = getItem(THEME_LOCAL_STORAGE_KEY);
  return theme ?? DEFAULT_THEME;
};

export const getThemeFromUrl = (): Theme => {
  const urlParams = new URLSearchParams(window.location.search);
  const theme = urlParams.get("theme") as Theme;
  return theme ?? DEFAULT_THEME;
};

export const saveThemeToLocalStorage = (theme: Theme): void => {
  saveItem(THEME_LOCAL_STORAGE_KEY, theme);
};
